import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Card, Statistic } from 'antd';

export const Color = {
  Agree: '#4bb849',
  Disagree: '#ee4448'
};

export function Agree() {
  return (
    <Card bordered={false}>
      <Statistic
        title="Agree"
        value={1128}
        precision={0}
        valueStyle={{ color: Color.Agree }}
        prefix={<CheckCircleOutlined />}
        suffix="ppl"
      />
    </Card>
  );
}

export function Disagree() {
  return (
    <Card bordered={false}>
      <Statistic
        title="Disagree"
        value={93}
        precision={0}
        valueStyle={{ color: Color.Disagree }}
        prefix={<CloseCircleOutlined />}
        suffix="ppl"
      />
    </Card>
  );
}
